import { Link } from "react-router-dom";
import { Scale, ShieldCheck, BookOpenCheck, Users } from "lucide-react";
import { CRITICAL_PRINCIPLES, IMAGES } from "@/data/content";
import { Reveal, Eyebrow, SectionTitle } from "@/components/common";

const ICONS = [Scale, BookOpenCheck, ShieldCheck, Users];

export default function CriticalStudies() {
  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="critical-studies-page">
      <section className="relative py-24 lg:py-32 border-b border-indic-gold/15">
        <img src={IMAGES.templeTower} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1021]/75 to-indic-indigo" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-8">
          <Eyebrow>Critical Inquiry</Eyebrow>
          <h1 className="mt-4 font-serif text-5xl lg:text-7xl font-semibold text-amber-50 max-w-3xl leading-[1.05]">Scholarship without fear or flattery</h1>
          <p className="mt-6 max-w-2xl text-lg text-slate-300/90 leading-relaxed">
            INDIC preserves historical knowledge while encouraging intellectual freedom. We respect living traditions without requiring religious adherence — and we support rigorous criticism without hostility toward people based on their identity.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Reveal><SectionTitle eyebrow="Our Commitments" title="Four principles of critical study" /></Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
            {CRITICAL_PRINCIPLES.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <Reveal key={p.h} delay={(i % 2) * 0.08}>
                  <div className="rounded-sm border border-indic-card-border bg-indic-card p-7 h-full" data-testid={`principle-${i}`}>
                    <Icon className="text-indic-gold" size={26} />
                    <h3 className="mt-4 font-serif text-2xl text-amber-50">{p.h}</h3>
                    <p className="mt-2 text-slate-300/85 leading-relaxed">{p.p}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal delay={0.1}>
            <div className="mt-12 rounded-sm border border-indic-gold/20 bg-[#080c1a] p-8 text-center">
              <p className="font-serif text-2xl lg:text-3xl text-amber-50/90 italic max-w-3xl mx-auto leading-snug">
                “Reality outranks authority because reality is where every authority must finally answer.”
              </p>
              <Link to="/editorial-policy" className="mt-6 inline-block text-sm font-semibold text-indic-gold hover:text-indic-gold-soft underline underline-offset-4" data-testid="critical-editorial-link">Read our full editorial policy →</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
